import { RenderHTML } from "@components/render_html";
import { htmlFromMarkdown } from "@root/react/helpers/markdown";
import { PressItemModel } from "@root/types";
import { formatDateString, SHORT_MONTH_DAY_YEAR } from "@services/date_helpers";
import cx from "classnames";
import React, { FC, useCallback, useMemo } from "react";
interface PressCardProps {
  pressItem: Omit<PressItemModel, "slug" | "id">;
  classes?: string;
}

const PressCard: FC<PressCardProps> = ({ pressItem, classes }) => {
  const byline = useMemo(() => {
    if (pressItem.source && pressItem.link) {
      return (
        <a>
          <span className="press-card--source-prefix">Read more at </span>
          {pressItem.source}
        </a>
      );
    } else if (pressItem.source) {
      return (
        <>
          <span className="press-card--source-prefix">Read more at </span>
          {pressItem.source}
        </>
      );
    }
    return null;
  }, [pressItem.source, pressItem.link]);

  const handleClick = useCallback(() => {
    if (pressItem.link) {
      window.open(pressItem.link);
    }
    return undefined;
  }, [pressItem.link]);
  return (
    <article className={cx(classes, "press-card")}>
      <div className="press-card--tagline" onClick={handleClick}>
        <h1>{pressItem.tagline}</h1>
        <div className="press-card--publish-date">
          {formatDateString(pressItem.publishedDate, SHORT_MONTH_DAY_YEAR)}
        </div>
      </div>
      <div className="press-card--description" onClick={handleClick}>
        <p className="press-card--headline">{pressItem.headline}</p>
        <blockquote>
          <RenderHTML html={htmlFromMarkdown(pressItem.description ?? "")} />
        </blockquote>
      </div>
      <div className="press-card--byline" onClick={handleClick}>
        <div className="press-card--source">{byline}</div>
      </div>
    </article>
  );
};

export { PressCard };
